import { getTypographyVariants } from '@theme/styleOverrides/typography';
import { tablePagination } from '@components/table/deprecated/PanelTable.styles';
import { Theme } from '@mui/material/styles';

const columnStyles = {
  '& .MuiDataGrid-columnHeaders': {
    borderBottom: `1px solid black`,
    borderColor: 'border.main',
  },

  '& .MuiDataGrid-columnHeaderTitle': {
    fontSize: (theme: Theme) => getTypographyVariants(theme.palette.fontSize).tableHeader.fontSize,
    lineHeight: (theme: Theme) => getTypographyVariants(theme.palette.fontSize).tableHeader.lineHeight,
    textTransform: (theme: Theme) => getTypographyVariants(theme.palette.fontSize).tableHeader.textTransform,
    color: 'text.subdued',
    fontWeight: 700,
  },
  '& .MuiDataGrid-columnHeader--alignRight .MuiDataGrid-columnHeaderTitleContainer': {
    flexDirection: 'row',
  },
  '& .MuiDataGrid-columnHeader': {
    // color: colors.BLACK_60 // THEME CHECK i do not think this does anything, leaving in case we see a bug in this area
    '&:focus': {
      outline: 'none',
    },
    '&:focus-within': {
      outline: 'none',
    },
  },
  '& .MuiDataGrid-columnHeader--sorted': {
    color: 'dataGrid.columnHeaderSorted',
    '& .MuiIconButton-root': {
      color: 'dataGrid.columnHeaderSorted',
    },
  },
} as const;

const cellStyles = {
  '& .MuiDataGrid-cell': {
    borderBottom: `1px solid black`,
    borderColor: 'other.divider',
    fontWeight: 'normal',
    paddingLeft: '',
    '&:focus': {
      outline: 'none',
    },
    '&:focus-within': {
      outline: 'none',
    },
  },
} as const;

const rowStyles = {
  '& .MuiDataGrid-row:hover': {
    backgroundColor: (theme: Theme) =>
      theme.palette.theme === 'lio' ? theme.palette.background.main : `${theme.palette.background.light}120`,
  },
} as const;

const footerStyles = {
  '& .MuiDataGrid-footerContainer': {
    minHeight: '68px',
  },
} as const;

const dataGrid = {
  position: 'absolute',
  height: '100%',
  width: '100%',
  '& .MuiDataGrid-main > div:first-of-type': {
    zIndex: '1',
  },
  '&.MuiDataGrid-root': {
    '--DataGrid-rowBorderColor': 'none',
    borderTop: 'none',
    borderTopLeftRadius: 0,
    borderTopRightRadius: '8px',
    borderBottomRightRadius: '8px',
    borderBottomLeftRadius: '8px',
    '& .DataGridRowBorderColor:': 'transparent',
    '& .MuiTablePagination-root': {
      ...tablePagination,
    },
  },
  ...columnStyles,
  ...cellStyles,
  ...rowStyles,
  ...footerStyles,
} as const;

const dataGridContainer = {
  position: 'relative',
  height: '100%',
  width: '100%',
  minHeight: '200px',
  backgroundColor: (theme: Theme) => theme.palette.dataGrid?.background ?? theme.palette.background.light,
  borderTopRightRadius: '8px',
  borderBottomRightRadius: '8px',
  borderBottomLeftRadius: '8px',
} as const;

export { dataGridContainer, dataGrid, tablePagination };
